import { z } from "zod";

export const setEventOnlineSchema = z.object({
  openTicketingWhenOnline: z.boolean(),
  activateBadgesWhenOnline: z.boolean(),
  setExhibitorsOnlineWhenOnline: z.boolean(),
  setProgramOnlineWhenOnline: z.boolean(),
});

export const defaultSetEventOnlineValues = {
  openTicketingWhenOnline: false,
  activateBadgesWhenOnline: false,
  setExhibitorsOnlineWhenOnline: false,
  setProgramOnlineWhenOnline: false,
};

export type SetEventOnlineForm = z.infer<typeof setEventOnlineSchema>;
